import {RootState} from "../../../../store";

export const getAuthError = (state: RootState) => state.authReducer.error;
export const getAuthErrorRegister = (state: RootState) => state.authReducer.errorRegister;
export const getAuthIsMainLoading = (state: RootState) => state.authReducer.isMainLoading;
export const getAuthIsNavbarLoading = (state: RootState) => state.authReducer.isNavbarLoading;
export const getAuthIsAuthentication = (state: RootState) => state.authReducer.isAuthentication;
export const getAuthIsSessionReady = (state: RootState) =>
    state.authReducer.isAuthentication || state.authReducer.isGuestSessionReady;
export const getAuthIsShowModal= (state: RootState) => state.authReducer.isShowModalAuth;
export const getAuthIsRegistrationSuccess = (state: RootState) => state.authReducer.isRegistrationSuccess;
export const getForgotPasswordState = (state: RootState) => state.authReducer.forgotPassword;
export const getResetPasswordState = (state: RootState) => state.authReducer.resetPassword;

